export enum ROUTES {
  HOME = '/',
  LOGIN = '/login',
  COMPANIES = '/companies',
  COMPANY_DETAILS = '/companies/:slug',
}